<template>
<div class="notifications">
  <div class="ui centered inline loader" :class="{'active': form.waiting}"></div>
  <dropdown v-model="form.model.read" :placeholder="'すべて'" @change="search()">
    <option value="">すべて</option>
    <option value="false">未読</option>
    <option value="true">既読</option>
  </dropdown>
  <pagination :pager="pager" :callback="search"></pagination>
  <table class="ui striped table">
    <thead>
      <tr>
        <th>タイトル</th>
        <th>受信日時</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="ntf in notifications">
        <td>
          <span v-if="!ntf.read" class="ui teal label">未読</span>
          <span v-else class="ui label">既読</span>
          <a class="clickable" :href="ntf.location" @click="dispatch(ntf)">{{ ntf.title }}</a>
        </td>
        <td>{{ ntf.created_at | formatDatetime }}</td>
      </tr>
    </tbody>
  </table>
</div>
</template>

<script>
export default {
    data: function() {
        return {
            form: this.createForm(),
            pager: this.createPager(15, this.query().offset),
            notifications: []
        };
    },
    created: function() {
        this.search(this.pager.current());
    },
    methods: {
        search: function(opt_position) {
            var position = opt_position || this.pager.first();
            this.merge(this.form.model, position);
            this.replaceStateQuery(this.form.model, ['limit']);
            this.form.get('/api/notifications', function(response) {
                this.notifications = response.data;
                this.pager.update(response.data, response);
            });
        },
        dispatch: function(ntf) {
            this.createForm({
                'ntf_id': ntf.id
            }).put(ntf.read_api_url, function() {
                window.location.href = ntf.location;
            });
        }
    }
};
</script>
